import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from 'styled-components'

import { LightTheme } from 'ui/bend'
import { ModalProvider } from 'context'

import { useToggleFocus } from 'hooks'

import ThemeWrapper from '../ThemeWrapper'

const StyledAdminWrapper = ({ children, ...rest }) => {
  // Because StyledWrapper is on StyledHeader, and StyledHeader loads on all pages (except Admin), we only need to attach global event listeners here.
  useToggleFocus()

  return (
    <ThemeProvider theme={LightTheme}>
      <ThemeWrapper color='primary' pb={['200px', '75px']} {...rest}>
        <ModalProvider>
          <Suspense fallback=''>{children}</Suspense>
        </ModalProvider>
      </ThemeWrapper>
    </ThemeProvider>
  )
}

StyledAdminWrapper.propTypes = {
  children: PropTypes.node.isRequired
}

export default StyledAdminWrapper
